import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import patchStoreOrderDetails from './postStoreOrderDetails';

export interface IPostStoreOrderDetailsPayload {
  order_guid: string;
  shipping_method: string;
  shipment_number: string;
  shipping_receipt: File;
  delivery_date: string;
}

const usePostStoreOrderDetails = (handleAfterSuccess?: () => void) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPostStoreOrderDetailsPayload) => {
      return patchStoreOrderDetails(payload);
    },
    onSuccess: data => {
      handleAfterSuccess && handleAfterSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostStoreOrderDetails;
